import {
  createAdminProjectTask,
  deleteAdminProjectTask,
  getAdminProjectTasks,
  updateAdminProjectTask,
} from '@lib/api'
import { adminProjectTasksKeys, searchTasksKeys } from '@lib/keys'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const useProjectTasks = (projectId: number) =>
  useQuery(adminProjectTasksKeys.forProject(projectId), () =>
    getAdminProjectTasks(projectId),
  )

const useInvalidateProjectTasks = (projectId: number) => {
  const queryClient = useQueryClient()

  return () => {
    void queryClient.invalidateQueries(
      adminProjectTasksKeys.forProject(projectId),
    )
    void queryClient.invalidateQueries(searchTasksKeys.all)
  }
}

export const useCreateProjectTask = (projectId: number) => {
  const invalidate = useInvalidateProjectTasks(projectId)

  return useMutation(
    ({ name }: { name: string }) => createAdminProjectTask(projectId, name),
    { onSuccess: invalidate },
  )
}

export const useUpdateProjectTask = (projectId: number) => {
  const invalidate = useInvalidateProjectTasks(projectId)

  return useMutation(
    ({ id, name }: { id: number; name: string }) =>
      updateAdminProjectTask(projectId, id, name),
    { onSuccess: invalidate },
  )
}

export const useDeleteProjectTask = (projectId: number) => {
  const invalidate = useInvalidateProjectTasks(projectId)

  return useMutation(
    ({ id }: { id: number }) => deleteAdminProjectTask(projectId, id),
    { onSuccess: invalidate },
  )
}
